import WinterWrapUp from './WinterWrapUp';
export default WinterWrapUp;
